import { logger } from "@/sentry";

declare global {
  interface Window {
    _cio: any[];
  }
}

export const identifyUser = (userId: string, traits: any = {}) => {
  if (typeof window !== "undefined" && window._cio) {
    // This sends the data AND checks for pending In-App Messages
    window._cio.push([
      "identify",
      {
        id: userId,
        ...traits,
      },
    ]);
  } else {
    logger.warn("Customer.io is not loaded yet");
  }
};

export const resetUser = () => {
  if (typeof window !== "undefined" && window._cio) {
    window._cio.push(["reset"]);
  } else {
    logger.warn("Customer.io is not loaded yet");
  }
};
